import _ from 'underscore'
import Vue from 'vue'
import Chapter from '../../resources/chapter'

// This is an object where chapters will be stored
// with keys as the id, and chapter as the value
const state = {}

const getters = {
  allChapters(state) {
    return _.values(state);
  }
}

const actions = {
  getChapters(context) {
    console.log('Fetching chapters...')
    Chapter.query({}).then((res) => {
      context.commit(`RETRIEVE_CHAPTERS_SUCCESS`, {chapters: res.data})
    }, (res) => {
      Toast.error('Failed to retrieve chapters')
    })
  },

  // payload.chapter
  deleteChapter(context, payload) {
    Chapter.delete({id: payload.chapter.id}).then((res) => {
      context.commit(`DELETE_CHAPTER_SUCCESS`, {chapter: payload.chapter});
    }, (res) => {
      Toast.error('Failed to delete chapter')
    })
  },

  // payload.id, payload.changes
  updateChapter(context, payload) {
    Chapter.update({ id: payload.id }, payload.changes).then((res) => {
      context.commit(`UPDATE_CHAPTER_SUCCESS`, { chapter: res.data });
      if (_.isFunction(payload.callback)) payload.callback();
    }, (res) => {
      Toast.error('Failed to save chapter')
    })
  },

  // createChapter(context, payload) {
  //   Chapter.save(payload.chapter).then((res) => {
  //     context.commit(CREATE_CHAPTER_SUCCESS, {chapter: res.data});
  //   }, (res) => {
  //     console.log('Error, failed to create chapter');
  //   })
  // },

}

const mutations = {
  LOGOUT_SUCCESS() {
    // Clear state
    for(let prop in state) Vue.delete(state, prop)
  },

  RETRIEVE_CHAPTERS_SUCCESS(state, payload) {
    // #todo - We may want to completely clear the state at this point
    _.each(payload.chapters, (chapter) => {
      Vue.set(state, chapter.id, chapter);
    })
  },

  DELETE_CHAPTER_SUCCESS(state, payload) {
    Vue.delete(state, payload.chapter.id);
  },

  // payload.chapter
  UPDATE_CHAPTER_SUCCESS(state, payload) {
    Vue.set(state, payload.chapter.id, payload.chapter);
  },

  CREATE_CHAPTER_SUCCESS(state, payload) {
    Vue.set(state, payload.chapter.id, payload.chapter);
  },

}



export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/chapters.js